/* eslint-disable */
import HttpService from '../HttpService'

export default class IntegratorMovementService {
  constructor() {
    this._httpService = new HttpService('/sdi/movement-integrator');
  }

  async FetchIntegrationMovements(parameters) {
    return await this._httpService.get(`?${parameters}`);
  }

  async FetchIntegrationMovementLogs(integratorMovementId) {
    return await this._httpService.get(`/${integratorMovementId}/execution`);
  }

  async ResendMovement(integratorMovementId) {
    return await this._httpService.post(`/${integratorMovementId}/resend`);
  }
}
